import React from 'react';
import { Section } from './ui/Section';
export function Method3S() {
  return <Section id="metoda" background="white" data-id="element-173">
      <div className="max-w-4xl mx-auto mb-12 text-center" data-id="element-174">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-6" data-id="element-175">
          Metoda 3S: Știință · Suflet · Spirit
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-176">
          Procesul prin care îți armonizezi mintea, corpul și sufletul, ca să
          ieși din anxietate, frici și blocaje și să ajungi la liniște
          interioară, claritate și încredere.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 items-center max-w-5xl mx-auto" data-id="element-177">
        {/* SVG Venn Diagram */}
        <div className="relative flex justify-center items-center" data-id="element-178">
          <svg viewBox="0 0 400 400" className="w-full max-w-sm md:max-w-md h-auto drop-shadow-lg" data-id="element-179">
            {/* Circle 1: Top Left - Science */}
            <circle cx="150" cy="150" r="100" fill="rgba(106, 90, 205, 0.15)" stroke="#6A5ACD" strokeWidth="1.5" data-id="element-180" />
            <text x="110" y="140" className="text-xs font-bold fill-brand-primary uppercase tracking-wider" data-id="element-181">
              Știință
            </text>

            {/* Circle 2: Top Right - Soul */}
            <circle cx="250" cy="150" r="100" fill="rgba(254, 197, 229, 0.25)" stroke="#FEC5E5" strokeWidth="1.5" data-id="element-182" />
            <text x="260" y="140" className="text-xs font-bold fill-brand-secondary-dark uppercase tracking-wider" data-id="element-183">
              Suflet
            </text>

            {/* Circle 3: Bottom - Spirit */}
            <circle cx="200" cy="240" r="100" fill="rgba(54, 130, 18, 0.08)" stroke="#368212" strokeWidth="1.5" data-id="element-184" />
            <text x="180" y="280" className="text-xs font-bold fill-brand-accent uppercase tracking-wider" data-id="element-185">
              Spirit
            </text>

            {/* Center Intersection */}
            <text x="200" y="190" textAnchor="middle" className="text-sm font-bold fill-brand-text font-serif" data-id="element-186">
              Armonie
            </text>
            <text x="200" y="205" textAnchor="middle" className="text-sm font-bold fill-brand-text font-serif" data-id="element-187">
              Interioară
            </text>
          </svg>
        </div>

        {/* Text Content */}
        <div className="space-y-6" data-id="element-188">
          <div className="flex gap-4 items-start p-4 rounded-xl bg-brand-primary/5 border border-brand-primary/10" data-id="element-189">
            <div className="w-10 h-10 rounded-full bg-brand-primary/15 flex items-center justify-center flex-shrink-0 text-brand-primary font-bold text-lg" data-id="element-190">
              1
            </div>
            <div data-id="element-191">
              <h3 className="text-lg font-bold text-brand-text mb-1" data-id="element-192">
                ȘTIINȚĂ
              </h3>
              <p className="text-gray-700 text-[15px] leading-relaxed" data-id="element-193">
                Psihoterapie integrativă + Metoda Feuerstein (înțelegi și
                restructurezi tiparele care te conduc)
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start p-4 rounded-xl bg-brand-secondary/10 border border-brand-secondary/20" data-id="element-194">
            <div className="w-10 h-10 rounded-full bg-brand-secondary/30 flex items-center justify-center flex-shrink-0 text-brand-secondary-dark font-bold text-lg" data-id="element-195">
              2
            </div>
            <div data-id="element-196">
              <h3 className="text-lg font-bold text-brand-text mb-1" data-id="element-197">SUFLET</h3>
              <p className="text-gray-700 text-[15px] leading-relaxed" data-id="element-198">
                Procesare emoțională, introspecție, exerciții practice (îți
                recapeți identitatea și stabilitatea)
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start p-4 rounded-xl bg-brand-accent/5 border border-brand-accent/10" data-id="element-199">
            <div className="w-10 h-10 rounded-full bg-brand-accent/10 flex items-center justify-center flex-shrink-0 text-brand-accent font-bold text-lg" data-id="element-200">
              3
            </div>
            <div data-id="element-201">
              <h3 className="text-lg font-bold text-brand-text mb-1" data-id="element-202">SPIRIT</h3>
              <p className="text-gray-700 text-[15px] leading-relaxed" data-id="element-203">
                Reconectare autentică, practici simple, credință trăită (înveți
                să te sprijini pe Dumnezeu, nu pe frică)
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}